// Copyright (c) 2016 Deere & Company

import Parts, {getDefaultState} from '../state/parts';
import actions from '../../action-list';

const addPart = (state, action) =>
    Parts.update(state, {
        [action.partDetails.partNumber]: {
            $set: action.partDetails
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_PART_DETAILS]: addPart
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/shared/reducers/part-details.js